
import React from 'react';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/fef5b4246026b9434da1318320fc441f.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
      </div>
      <div className="relative z-10 w-full max-w-none px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-bold text-white mb-6 leading-none tracking-tight">
            BUSINESS<br />
            DEVELOPMENT<br />
            <span className="block mt-4 text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light tracking-widest">
              AUTHORITY
            </span>
          </h1>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mt-16">
          <a
            href="#services"
            className="bg-white hover:bg-gray-100 text-black px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Explore Our Services
          </a>
          <a
            href="#contact"
            className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 whitespace-nowrap"
          >
            Get Started Today
          </a>
        </div>

        {/* Business Areas */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          <div className="bg-gray-900/80 backdrop-blur-sm rounded-lg p-6 hover:bg-gray-800/80 transition-all duration-300">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-robot-line text-black text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">AI Consulting</h3>
            <p className="text-gray-300 text-sm">Transform your business with cutting-edge AI solutions</p>
          </div>
          
          <div className="bg-gray-900/80 backdrop-blur-sm rounded-lg p-6 hover:bg-gray-800/80 transition-all duration-300">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-line text-black text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Real Estate</h3>
            <p className="text-gray-300 text-sm">Professional real estate development and investment</p>
          </div>
          
          <div className="bg-gray-900/80 backdrop-blur-sm rounded-lg p-6 hover:bg-gray-800/80 transition-all duration-300">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-book-line text-black text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Published Books</h3>
            <p className="text-gray-300 text-sm">45+ books on business, AI, and financial strategies</p>
          </div>
          
          <div className="bg-gray-900/80 backdrop-blur-sm rounded-lg p-6 hover:bg-gray-800/80 transition-all duration-300">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-plane-line text-black text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Travel Authority</h3>
            <p className="text-gray-300 text-sm">Comprehensive travel management and planning services</p>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};
